import { Component, Input} from '@angular/core';
import { ModalComponent } from './modal';

@Component({
    selector: 'modal-header',
    template: `
        <div class="modal-header">
            <ng-content></ng-content>
            <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()" [hidden]="!showClose"></button>
        </div>
    `,
    standalone: false
})
export class ModalHeaderComponent {
    @Input('show-close') showClose = false;
    constructor(public modal: ModalComponent) { }
}
